module.exports = __webpack_public_path__ + "static/johan-dimitri-portratt-5c91fd2da027ccad8ef9e14bc046d67d.png";